import WifiOffIcon from "@mui/icons-material/WifiOff";
import {
    Box,
    Button,
    Grid,
    Typography,
} from "@mui/material";

import { btnsNamesConstants, globalConstants, viewsConstants } from "@/constants";

export const OfflineView = () => (
    <Grid
        alignItems="center"
        flexDirection="column"
        height="100vh"
        justifyContent="center"
        margin="auto"
        textAlign="center"
        width="90%"
        container
    >
        <Box>
            <WifiOffIcon
                color="primary"
                sx={{
                    fontSize: 64,
                    mb: 2, 
                }}
            />
            <Typography
                color="primary"
                component={globalConstants.h1}
                variant="h5"
                gutterBottom
            >
                {viewsConstants.offline.title}
            </Typography>
            <Typography
                marginBottom="24px"
                variant="body1"
            >
                {viewsConstants.offline.description}
            </Typography>
            <Button
                size="large"
                variant="contained"
                onClick={() => window.location.reload()}
            >
                {btnsNamesConstants.reload}
            </Button>
        </Box>
    </Grid>
);
